import { AppDispatch } from 'App';
import { CategoriesActionsEnum } from 'store/reducers/categoriesReducer/categoriesTypes';
import Categories from 'api/classes/Categories';

export const getCategoriesAction = () => async(dispatch: AppDispatch) => {
  const { success, data }: any = await Categories.getCategories();

  if (success) {
    dispatch({
      type: CategoriesActionsEnum.GetCategories,
      payload: { isLoading: false, isUpdated: true, results: data.results },
    });
  }
};
